export const POSTPONED_COMMISSIONS_ROUTE_PREFIX = "/commissions/postponed";

export const POSTPONED_COMMISSIONS_ROUTE_PATHS = {
  list: { path: "*", to: POSTPONED_COMMISSIONS_ROUTE_PREFIX },
};
